import React, { useEffect } from "react";
import { Button, Flex } from "antd";
import { EnterOutlined, DeleteOutlined } from "@ant-design/icons";
import DataTable from "../Common/DataTable";
import useDeletePlateItem from "../../functions/ItemDetails/deletePlateItem";

export default function ItemsTable(props) {
  const {
    plates,
    setPlates,
    tableRef,
    tableHeightOffset,
    selectedPlateIndex,
    setActiveTabKey,
    selectedItemKey,
    setSelectedItemKey,
    expandedRowKeys,
    setExpandedRowKeys,
    isDisableButton,
    setSelectedSubCategory,
    filterRef,
  } = props;

  const { deletePlateItem } = useDeletePlateItem();

  const COLUMNS = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Unit Price",
      dataIndex: "unit_price",
      key: "unit_price",
      render: (t, r, i) => "RM " + t.toFixed(2),
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      key: "quantity",
      width: 40,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (t, r, i) =>
        "RM " + ((r.unit_price ?? 0) * (r.quantity ?? 0)).toFixed(2),
    },
    {
      title: "",
      render: (t, r, i) => (
        <DeleteOutlined
          style={{
            fontSize: 16,
            color: "red",
            display: isDisableButton.delete_item_btn ? "none" : "block",
          }}
          onClick={() => {
            handleDelete(r.key);
          }}
        />
      ),
      width: 40,
    },
  ];

  const toggleExpandRow = (key) => {
    setExpandedRowKeys((prevExpandedRowKeys) => {
      if (prevExpandedRowKeys.includes(key)) {
        setActiveTabKey(1);
        setSelectedItemKey(null);
        return [];
      } else {
        setActiveTabKey(2);
        setSelectedItemKey(key);
        return [key];
      }
    });
  };

  const handleDelete = (key) => {
    let cloned_plates = JSON.parse(JSON.stringify(plates));
    cloned_plates[selectedPlateIndex]["items"] = cloned_plates[
      selectedPlateIndex
    ]["items"].filter((item) => item.key !== key);

    setPlates(cloned_plates);
    setSelectedItemKey(null);
    setExpandedRowKeys((prevExpandedRowKeys) =>
      prevExpandedRowKeys.filter((k) => k !== key)
    );
    if (!key.toString().includes("item")) {
      deletePlateItem(key);
    }
  };

  useEffect(() => {
    if (!selectedItemKey) {
      setExpandedRowKeys([]);
    }
  }, [selectedItemKey]);

  return (
    <DataTable
      table_column={COLUMNS}
      table_data={plates[selectedPlateIndex]?.items ?? []}
      layoutRef={tableRef}
      filterRef={filterRef}
      size={"small"}
      tableWrapperViewportHeight={1}
      tableHeightOffset={tableHeightOffset}
      show_size_changer={false}
      default_page_size={100}
      pagination_position={["none", "none"]}
      scroll_x={null}
      expandable={{
        expandedRowRender: (record) => (
          <Flex gap={"middle"} vertical>
            <Flex
              className="expanded-row"
              justify="space-between"
              align="center"
            >
              <p style={{ margin: 0, marginLeft: 10 }}>
                <EnterOutlined
                  style={{
                    marginRight: 20,
                    transform: "scaleX(-1)",
                    fontSize: 17,
                    color: "grey",
                  }}
                />
                {record.sub_category}
              </p>
            </Flex>
          </Flex>
        ),
        expandedRowKeys: expandedRowKeys,
        expandIcon: () => null,
        expandIconColumnIndex: -1,
        expandedRowClassName: (record) => {
          return record.key == selectedItemKey
            ? "selected-expanded-row"
            : "table-row";
        },
      }}
      on_row={(record) => ({
        onClick: () => {
          toggleExpandRow(record.key);
          setSelectedSubCategory(record.sub_category);
        },
        onMouseEnter: (e) => e.stopPropagation(),
        onMouseLeave: (e) => e.stopPropagation(),
      })}
      selectedRow={selectedItemKey}
      row_bold={true}
      two_tone={true}
    />
  );
}
